import { render, staticRenderFns } from "./OpenBookingPaySuccess.vue?vue&type=template&id=a769dfa0"
import script from "./OpenBookingPaySuccess.vue?vue&type=script&lang=js"
export * from "./OpenBookingPaySuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports